import { Card, CardContent, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { CoinNewsStyles } from "./styles/CoinNews.styles";
import ExternalLinkWarning from "../core/ExternalLinkWarning";

interface CoinProps {
  source: string;
  date: string;
  title: string;
  key: number;
  urlReference: string;
}

export default function CoinsNews(props: CoinProps) {
  const classes = CoinNewsStyles();
  const [externalWarning, setExternalWarning] = useState(false);
  const [selectedUrl, setSelectedUrl] = useState("");
  const setUserSelectionCallBack = (permission: string) => {
    if (permission === "Confirm") return window.open(selectedUrl, "_blank");
  };
  const handleExternalNavigation = (link: string) => {
    setExternalWarning(true);
    setSelectedUrl(link);
  };
  return (
    <Card className={classes.card}>
      <ExternalLinkWarning
        option={externalWarning}
        setExternalWarning={setExternalWarning}
        handleSelection={setUserSelectionCallBack}
        selectedUrl={props.urlReference}
      />
      <CardContent
        onClick={() => {
          handleExternalNavigation(props.urlReference);
        }}
        sx={{
          padding: "0px",
          "&:last-child": {
            paddingBottom: 0,
          },
        }}>
        {props.title.length < 50 ? (
          <Typography className={classes.title} gutterBottom component="div">
            {props.title}
          </Typography>
        ) : (
          <Typography className={classes.title} gutterBottom component="div">
            {props.title.substring(0, 60)}
            {"..."}
          </Typography>
        )}
        <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
          <Typography className={classes.source} variant="body2" color="text.secondary">
            {props.source}
          </Typography>
          <Typography className={classes.source} variant="body2" color="text.secondary">
            {props.date}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
